import { getWujiFetchAccess, doubleCheckLoginStatusAndDisplayLoginIfNeeded } from "./getAccess";
import axios from 'axios';
export async function wujiAxiosAIScf(path, config) {
    const access = await getWujiFetchAccess({ method: config.method || 'GET' });
    if (!access)
        throw new Error('Failed to get wujiFetch access');
    const actualUrl = `${access.baseUrl}${path}`;
    const actualConfig = {
        ...config,
        url: actualUrl,
        params: { ...config.query, ...config.params },
        headers: {
            ...config.headers,
            Authorization: `Bearer ${access.token}`,
            'X-Requested-With': 'XMLHttpRequest',
        },
    };
    try {
        const res = await axios.request(actualConfig);
        return res;
    }
    catch (error) {
        if (error.response) {
            if (error.response.status === 401 && !error.response.headers['X-Powered-By']?.startsWith('Wuji-Gogo-Scf-Proxy')) {
                doubleCheckLoginStatusAndDisplayLoginIfNeeded();
            }
        }
        throw error;
    }
}
export async function wujiFetchAIScf(path, options) {
    const access = await getWujiFetchAccess({ method: options?.method || 'GET' });
    if (!access)
        throw new Error('Failed to get wujiFetch access');
    // 发起调用
    const headers = new Headers(options?.headers || {});
    headers.set('Authorization', `Bearer ${access.token}`);
    headers.set('X-Requested-With', 'XMLHttpRequest');
    const actualUrl = `${access.baseUrl}${path}`;
    const actualOptions = {
        ...options,
        credentials: 'include',
        headers,
    };
    const res = await fetch(actualUrl, actualOptions);
    if (!res.ok) {
        if (res.status === 401 && !res.headers.get('X-Powered-By')?.startsWith('Wuji-Gogo-Scf-Proxy')) {
            doubleCheckLoginStatusAndDisplayLoginIfNeeded();
            // TODO: 需不需要重发请求？好像会有问题，先算了
            // const resp = await doubleCheckLoginStatusAndDisplayLoginIfNeeded();
            // if (resp === 'sso-login-done') return await fetch(actualUrl, actualOptions);
        }
    }
    return res;
}
